export const Languages = {
  eng: {
    title: "Also available on iOS and Android.",

    para: "This is just testing text dont take it serious",
  },
  chi: {
    title: "也可在 iOS 和 Android 上使用",

    para: "这只是测试文本不要认真",
  },
};
